enum TYPE_RESUME_ELEMENT {
  ANOMALIES = "ANOMALIES",
  CARACTERISTIQUES = "CARACTERISTIQUES",
  CASERNE = "CASERNE",
  CIS = "CIS",
  DISPONIBILITE = "DISPONIBILITE",
  GESTIONNAIRE = "GESTIONNAIRE",
  LOCALISATION = "LOCALISATION",
  OBSERVATION = "OBSERVATION",
  TOURNEE = "TOURNEE",
}
export default TYPE_RESUME_ELEMENT;
